import React from 'react';
import { Form, Input, Button, Select } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';

import './filter.css';

function Filter({ users, filters, setFilters, applyFilters, loadData, isAdmin }) {
    const [form] = Form.useForm();

    function onFinish(values) {
        const newFilters = {
            seller: values.seller || '',
            company: values.company || '',
            priority: values.priority || '',
            hasProposal: values.hasProposal !== undefined ? values.hasProposal : '',
            originListing: values.originListing || '',
            search: values.search || ''
        };

        applyFilters(newFilters);
    }

    function clearFilters() {
        form.resetFields();
        setFilters({});
        applyFilters({});
    }

    return (
        <div className="interested-customers-filter">
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                initialValues={filters}
            >
                {users.length > 0 && (
                    <Form.Item name="seller" label="Vendedor">
                        <Select
                            placeholder="Todos"
                            allowClear
                            style={{ width: 180 }}
                        >
                            {users.map(user => (
                                <Select.Option key={user._id} value={user._id}>
                                    {user.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                )}

                <Form.Item name="priority" label="Prioridade">
                    <Select
                        placeholder="Todas"
                        allowClear
                        style={{ width: 120 }}
                    >
                        <Select.Option value="high">Alta</Select.Option>
                        <Select.Option value="medium">Média</Select.Option>
                        <Select.Option value="low">Baixa</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item name="hasProposal" label="Proposta">
                    <Select
                        placeholder="Todas"
                        allowClear
                        style={{ width: 100 }}
                    >
                        <Select.Option value={true}>Sim</Select.Option>
                        <Select.Option value={false}>Não</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item name="originListing" label="Origem">
                    <Input
                        placeholder="Origem da listagem"
                        style={{ width: 150 }}
                    />
                </Form.Item>

                <Form.Item name="search" label="Buscar" className="field search-input">
                    <Input
                        placeholder="Empresa, status..."
                        allowClear
                    />
                </Form.Item>

                <div className="filter-buttons">
                    <Form.Item style={{ marginBottom: 0, marginRight: 0 }}>
                        <Button onClick={clearFilters} icon={<ClearOutlined />} style={{ width: 140 }}>
                            Limpar
                        </Button>
                        <Button type="primary" htmlType="submit" icon={<SearchOutlined />} style={{ width: 140 }}>
                            Filtrar
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </div>
    );
}

export default Filter;
